import React from "react";
import { Rnd } from "react-rnd";
import {
  getSelectionOutlineOffset,
  toNumericStyleValue,
} from "../../Uitls/Util";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";

export const EditorCanvasImageItem = ({ items, index }) => {
  const {
    playPauseRef,
    isAspectRatioLocked,
    handleComponentsDrag,
    handleComponentsDragStop,
    callOnResizeStop,
    updateFontOnResize,
    multiSelectedComps,
    selectedComponent,
    canvasDimension,
    playPause,
    toggleAnimatedBanner,
    sendSelectedComponent,
    setFroalaIndex,
    setContainerID,
    setCurrentIdZindex,
    setDisplayColorPicker,
    setVisibility,
    handleCtrlClick,
    setEditComponent,
    editComponentRef,
    handleDeleteKey,
    isDragged,
  } = useEditorMainPageContext();

  if (items?.componentType !== "Image") return null;

  const toCssLength = (value) => {
    if (value === "" || value == null) return 0;
    if (typeof value === "number") return `${value}px`;
    if (/px$|%$|em$|rem$/i.test(value)) return value;
  
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? value : `${parsed}px`;
  };

  const imgDivStyles = {
    height: "100%",
    width: "100%",
    boxSizing: "border-box",
    overflow: "hidden",
    backgroundClip: "padding-box",
    backgroundImage: `url(${items.componentStyles.background})`,
    backgroundRepeat: items.componentStyles.backgroundRepeat,
    borderTopLeftRadius: toCssLength(items.componentStyles.borderTopLeftRadius),
    borderTopRightRadius: toCssLength(items.componentStyles.borderTopRightRadius),
    borderBottomLeftRadius: toCssLength(items.componentStyles.borderBottomLeftRadius),
    borderBottomRightRadius: toCssLength(items.componentStyles.borderBottomRightRadius),
    border: items.componentStyles.border,
    // The picture is sized to the whole layer box, so it has to be positioned
    // from that same box. With the default padding-box origin it starts after
    // the top/left border and its right/bottom edge disappears under the
    // opposite border, which reads as the border cutting into the image.
    backgroundOrigin: "border-box",
    backgroundSize: "inherit",
    ease: items.componentStyles.ease,
    display: items?.componentStyles?.hideBoolean ? "none" : "",
  }
  
  return (
    <Rnd
      resizeHandleClasses={{
        topRight: "topAnchorRight",
        topLeft: "topAnchorLeft",
        bottomLeft: "bottomAnchorLeft",
        bottomRight: "bottomAnchorRight",
        top: "horizontalAnchorCenter",
        bottom: "horizontalAnchorCenter",
        left: "verticallAnchorCenter",
        right: "verticallAnchorCenter",
      }}
      disableDragging={
        items?.componentStyles?.hideBoolean ||
        items?.componentStyles?.lockBoolean ||
        !playPauseRef.current.animationCompleted
      }
      enableResizing={
        !items?.componentStyles?.hideBoolean &&
        !items?.componentStyles?.lockBoolean &&
        playPauseRef.current.animationCompleted
      }
      size={{
        width: items.componentStyles.width,
        height: items.componentStyles.height,
      }}
      position={{
        x:
          toNumericStyleValue(items.componentStyles.left) +
          (parseInt(items.componentStyles.translateX) || 0),
        y:
          toNumericStyleValue(items.componentStyles.top) +
          (parseInt(items.componentStyles.translateY) || 0),
      }}
      lockAspectRatio={isAspectRatioLocked}
      onDrag={(e, d) => {
        handleComponentsDrag(d, items);
      }}
      onDragStop={(e, d) => {
        handleComponentsDragStop(e, d, items, index);
      }}
      onResizeStop={(e, direction, ref, delta, position) => {
        callOnResizeStop({
          id: items.id,
          width: ref.offsetWidth,
          height: ref.offsetHeight,
          x: position.x - (parseInt(items.componentStyles.translateX) || 0),
          y: position.y - (parseInt(items.componentStyles.translateY) || 0),
        });
      }}
      onResize={(e, direction, ref, delta, position) => {
        updateFontOnResize({
          id: items.id,
          width: ref.offsetWidth,
          height: ref.offsetHeight,
          x: position.x - (parseInt(items.componentStyles.translateX) || 0),
          y: position.y - (parseInt(items.componentStyles.translateY) || 0),
        });
      }}
      className={
        `${
          multiSelectedComps.length < 2 && selectedComponent.id === items.id
            ? "selectedComp div-dragresize-parent cs-container "
            : "div-dragresize-parent cs-container"
        }` +
        " " +
        `${
          multiSelectedComps.length > 1 && items.multiSelected === true
            ? "multipleSelection"
            : ""
        }`
      }
      data-aspect={items.componentStyles.aspectRatio}
      style={{
        pointerEvents:
          (!playPause.animationCompleted ||
            items.componentStyles.hideBoolean) &&
          "none",
        webkitTransformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
        transform: `rotate(${items.componentStyles.rotation}) rotateX(${items.componentStyles.rotationX}) rotateY(${items.componentStyles.rotationY}) scale(${items.componentStyles.scale})`,
        zIndex: items.componentStyles.zIndex,
        outlineOffset: getSelectionOutlineOffset(items.componentStyles),
        opacity:
          toggleAnimatedBanner === true ||
          items?.componentStyles?.hideBoolean === true
            ? items?.componentStyles?.opacity
            : items?.componentStyles?.compOpacity / 100,
        backgroundSize: `${items.componentStyles.width}px ${items.componentStyles.height}px`,
      }}
      key={index}
      id={items.id}
      type="image++"
      onClick={(e) => {
        sendSelectedComponent(e, index);
        setFroalaIndex(index);
        setContainerID(items.id);
        setCurrentIdZindex(e.currentTarget.id);
        setDisplayColorPicker(false);
        setVisibility(false);
        handleCtrlClick(e, items);
        setEditComponent(undefined);
        editComponentRef.current = undefined;
      }}
      tabIndex="0"
      onKeyDown={(e) => handleDeleteKey(e)}
    >
      <div
        data-image-fill="true"
        style={imgDivStyles}
        onMouseUp={(e) => {
          isDragged.mouseDown = false;
          sendSelectedComponent(e, index);
          setFroalaIndex(index);
          setContainerID(items.id);
          setCurrentIdZindex(e.currentTarget.id);
        }}
      ></div>
    </Rnd>
  );
};
